// Environment-aware configuration
// Vite automatically loads .env.development in dev mode and .env.production in build mode
export default {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || "https://localhost:61066/",
  IMAGE_URL: import.meta.env.VITE_API_IMAGE_URL || "https://localhost:61066",
  X_API_KEY: import.meta.env.VITE_X_API_KEY || "x5b9j8p2qRz3vdK1st7yf4ul6wa0ezcv",
  APP_ENV: import.meta.env.VITE_APP_ENV || "development",
};
